import router from './router';
import socket from './socket';
import root from './root';
import core from './core';
import modals from './modals';
import users from './users';
import projects from './projects';
import boards from './boards';
import folders from './folders';
import userBoardPreferences from './user-board-preferences';
import labels from './labels';
import lists from './lists';
import cards from './cards';
import attachments from './attachments';
import role from './roles';

export default {
  ...router,
  ...socket,
  ...root,
  ...core,
  ...modals,
  ...users,
  ...projects,
  ...boards,
  ...folders,
  ...userBoardPreferences,
  ...labels,
  ...lists,
  ...cards,
  ...attachments,
  ...role,
};
